/* Mobile/tablet user-menu dropdown — moved out of sections/bushnell-header.liquid's
   inline <script>. Header renders on every page (layout/theme.liquid,
   layout/bushnell-theme.liquid) and this code is fully static — no Liquid
   variables — so it's identical on every page load. As an external file it's
   fetched once and cached, instead of being re-sent inline with every page's
   HTML. */
(function () {
  if (window.__bnUserMenu) return;
  window.__bnUserMenu = true;
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('.bn-user-wrap.bn-open');
    var wrap = e.target.closest('.bn-user-wrap');
    if (!wrap) {
      open.forEach(function (w) { w.classList.remove('bn-open'); });
      return;
    }
    var btn = wrap.querySelector('.bn-user-btn');
    if (btn && btn.contains(e.target)) {
      var willOpen = !wrap.classList.contains('bn-open');
      open.forEach(function (w) { w.classList.remove('bn-open'); });
      if (willOpen) wrap.classList.add('bn-open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bn-user-wrap.bn-open').forEach(function (w) { w.classList.remove('bn-open'); });
    }
  });
})();
